<template>
  <div class="app-consumption-list">
    <div class="" v-for="c in consumptions" :key="c.type">
      <div class="progress-wrapper">
        <label :for="c.type" class="unit-display text-xs"
          >{{ formatNumber(c.consumed) }} <Unit :unit="c.unit"></Unit> / {{ formatNumber(c.max) }} <Unit :unit="c.unit"></Unit>
        </label>
        <progress :id="c.type" :value="c.consumed" :max="c.max"></progress>
      </div>
      <div class="info-wrapper">
        <p class="text-xl">
          Verfügbares Gesamtvolumen
          <img @click="showModal(c)" class="icon" src="/files/lidl/images/new-icons/svg/info.svg" alt="" />
        </p>
        <p class="text-2xl font-semibold">{{ formatNumber(c.consumed) }} <Unit :unit="c.unit"></Unit></p>
      </div>
    </div>
    <Modal @close="hideModal" :showModal="modalVisible" :consumptionDetails="selectedConsumption"></Modal>
  </div>
</template>

<script>
import Unit from './Unit.vue'
import Modal from './ConsumptionDetailsModal.vue'
export const stepName = 'view'
export default {
  name: 'ConsumptionList',
  data() {
    return {
      selectedConsumption: null,
      modalVisible: false
    }
  },
  props: {
    consumptions: {
      type: Array,
      default: () => []
    },
    tariffId: {
      type: String,
      default: ''
    },
    consumptionTitle: {
      type: Boolean,
      default: true
    }
  },
  components: {
    Unit,
    Modal
  },
  methods: {
    formatNumber(number) {
      if (this.$config?.calendar?.formatter?.numberFormatter === null) {
        return '-'
      }
      return this.$config.calendar.formatter.numberFormatter.format(number)
    },
    showModal(consumption) {
      this.selectedConsumption = consumption
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
      this.selectedConsumption = null
    }
  }
}
</script>
